<section class="text-center mt-2">
  <h1>Page Not Found</h1>
  <p>The page you were looking for was not found.</p>
  <a [routerLink]="['/dashboard']" class="btn btn-primary">Return to Your Dashboard</a>
</section>
